import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment, { months } from 'moment';
import waterScatterChart from '@/components/biChart/waterScatterChart';
import yearRange from '@/components/date/yearRange';
import weekRange from '@/components/date/weekRange';
import colControl from '@/components/colControl/colControl';
export default {
  name: 'scatterAnalysis',
  mixins: [GetSiteIdMixin],
  components: {
    waterScatterChart: waterScatterChart,
    yearRange: yearRange,
    weekRange: weekRange,
    colControl: colControl
  },
  data: function data() {
    return {
      colOptions: [],
      initNum: 0,
      value: [],
      reportType: '11',
      limitSelectDate: {},
      stime: '',
      etime: '',
      quantum: '',
      dateFormat: 'YYYY-MM-DD',
      chartBoxHeight: '604px',
      tableData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      }
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day'),
      max: moment().endOf('day')
    };
    this.value = moment().endOf('day'); // this.value[0] = this.limitSelectDate.min
    // this.value[1] = this.limitSelectDate.max

    this.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
  },
  watch: {
    currentSiteId: function currentSiteId(value) {}
  },
  methods: {
    onChange: function onChange() {
      var _this = this;

      var res = {
        result: JSON.parse(JSON.stringify(this.$refs.charts.dataSource))
      };
      var factors = [];
      var dataList = [];
      var itemStyle = {
        opacity: 0.8,
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: 'rgba(255, 255, 255, 0.5)'
      };
      var str = this.$refs.colControl.selectCol.join(',');
      res.result.records.forEach(function (item, index) {
        var items = [];

        for (var key in item.factor) {
          if (str.indexOf(key) > -1) {
            items.push(item.factor[key].value ? item.factor[key].value : 0);
          }
        }

        var dataStr;

        if (_this.reportType == 11) {
          dataStr = parseInt(item.dataTime.slice(item.dataTime.length - 8, item.dataTime.length).toString() + item.dataTime.slice(item.dataTime.length - 7, item.dataTime.length).toString());
        } else if (_this.reportType == 16) {
          dataStr = parseInt(item.dataTime);
        } else {
          dataStr = parseInt(item.dataTime.slice(item.dataTime.length - 2, item.dataTime.length - 1).toString() + item.dataTime.slice(item.dataTime.length - 1, item.dataTime.length).toString());
        }

        dataList.push([dataStr].concat(items));
      });
      var schemaData = [];
      res.result.query.factors.forEach(function (item, index) {
        if (str.indexOf(item.code) > -1) {
          schemaData.push({
            index: index + 1,
            text: item.alias || item.title
          });
          factors.push(item);
        }
      });
      var data = {
        schemaData: schemaData,
        seriesData: [{
          name: '',
          type: 'scatter',
          itemStyle: itemStyle,
          data: dataList
        }]
      };
      this.$refs.charts.changeChartInit(data, factors);
    },
    openCol: function openCol(index) {
      if (typeof index == 'number') {
        this.$refs.colControl[0].visible = true;
      } else {
        this.$refs.colControl.visible = true;
      }
    },
    moment: moment,
    searchChart: function searchChart() {
      this.initNum++;
    },
    dataTypeChange: function dataTypeChange(e) {
      this.reportType = e.target.value;

      if (e.target.value == '14') {
        this.value = [];
        this.limitSelectDate = {
          min: moment().startOf('day').subtract(1, 'month'),
          max: moment().endOf('day')
        };
        this.value[0] = this.limitSelectDate.min;
        this.value[1] = this.limitSelectDate.max;
        this.stime = this.limitSelectDate.min.format('YYYY-MM');
        this.etime = this.limitSelectDate.max.format('YYYY-MM');
      } else if (e.target.value == '11' || e.target.value == '12') {
        this.value = moment().endOf('day'); // this.value[0] = this.limitSelectDate.min
        // this.value[1] = this.limitSelectDate.max

        this.stime = moment().endOf('day').format('YYYY-MM-DD');
        this.etime = moment().endOf('day').format('YYYY-MM-DD');
      }
    },
    onMonthRangeChange: function onMonthRangeChange(value) {
      this.value = value;
      this.stime = moment(value[0]).format('YYYY-MM');
      this.etime = moment(value[1]).format('YYYY-MM');
    },
    handleRangeChange: function handleRangeChange(date, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1]; // console.log('实时数据/日数据', dateString)
    },
    getWeek: function getWeek(dt) {
      var d1 = new Date(dt);
      var d2 = new Date(dt);
      d2.setMonth(0);
      d2.setDate(1);
      var rq = d1 - d2;
      var days = Math.ceil(rq / (24 * 60 * 60 * 1000));
      var num = Math.ceil(days / 7);
      return num + 1;
    },
    onWeekRangeChange: function onWeekRangeChange(value) {
      console.log('周区间', value);
      this.stime = value[0];
      this.etime = value[1];
    },
    onYearRangeChange: function onYearRangeChange(value) {
      console.log('季/年区间', value);
      this.stime = value[0] + '';
      this.etime = value[1] + '';
    },
    onallChange: function onallChange(date, dateString) {
      // console.log('date, dateString',date, dateString)
      this.value = moment(dateString);
      this.stime = dateString;
      this.etime = dateString;
      console.log('实时数据/日数据', dateString);
    }
  }
};